import { processAPIResponse } from '@/utils/request';

import { fetchProductGroups } from '@/services/api/productGroup';

const initialState = {
  productGroupList: [],
  productGroupDrawer: {},
}

export default {
  namespace: 'productGroups',

  state: initialState,

  effects: {
    * fetchProductGroups({payload = {}}, {call, put, select}) {
      const {response, data} = yield call(fetchProductGroups);
      yield processAPIResponse({response, data}, {
        * onSuccess(data) {
          yield put({
            type: 'setProductGroups',
            payload: {
              productGroupList: data
            }
          })
        }
      }, 'data')
    },
  },

  reducers: {
    setProductGroups(state, action) {
      const {
        payload: {productGroupList},
      } = action;

      return {
        ...state,
        productGroupList
      };
    },

    toggleProductGroupDrawer(state, action) {
      return {
        ...state,
        productGroupDrawer: {
          ...(action.payload || {}),
          toggledAt: new Date().getTime(),
        },
      };
    },

    reset() {
      return initialState
    }
  }
};
